import { Component, EventEmitter, Output, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { S3Service } from '../_services/s3.service';

@Component({
  templateUrl: './image-upload-modal.component.html',
  styleUrls: ['./image-upload-modal.component.css']
})

export class ImageUploadModalComponent implements AfterViewInit {

  public loading = false;

  public imageUrl = '';

  private _dropZoneEventListerners = ['dragenter', 'dragover', 'dragleave', 'drop'];
  private _highlightFirstZone: () => void;
  isOnTopOfDropZone: boolean;

  private _unHighlightDropZone: () => void;
  private _handleDropZone: (e) => void;

  @ViewChild('dropZone', {static: false})
  dropZoneRef: ElementRef;

  get dropZone() {
    if (this.dropZoneRef) {
      return this.dropZoneRef.nativeElement as HTMLLabelElement;
    }
  }

  private _preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  @Output() hasError = new EventEmitter();

  constructor(
    private bsModalRef: BsModalRef,
    private s3Service: S3Service,
    private spinner: NgxSpinnerService) { }

  uploadAndClose(files: FileList) {
    if (files.length > 0) {
      const file = files[0];
      this.loading = true;
      this.spinner.show();

      this.s3Service.uploadFile(file, `images/${file.name}`.toLowerCase().replace(/ /g, '-'), "get-signed-s3-url")
        .subscribe(
          () =>  {
            this.loading = false;
            this.spinner.hide();
            this.hasError.emit(false);
            this.bsModalRef.hide();
          },
          error => {
            this.loading = false;
            this.spinner.hide();
            this.hasError.emit(true);
            this.bsModalRef.hide();
          });
    }
  }

  private _attachDragAndDropEventListeners() {
    this._highlightFirstZone = () => {
      this.isOnTopOfDropZone = true;
      this.dropZone.classList.add('highlight');
    };

    this._unHighlightDropZone = () => {
      this.isOnTopOfDropZone = false;
      this.dropZone.classList.remove('highlight');
    };

    this._handleDropZone = (e) => {
      const dt = e.dataTransfer;
      const files = dt.files;

      this.uploadAndClose(files);
    };

    this._dropZoneEventListerners.forEach(eventName => {
      this.dropZone?.addEventListener(eventName, this._preventDefaults, false);
    });

    ['dragenter', 'dragover'].forEach(eventName => {
      this.dropZone?.addEventListener(eventName, this._highlightFirstZone, false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
      this.dropZone?.addEventListener(eventName, this._unHighlightDropZone, false);
    });

    this.dropZone?.addEventListener('drop', this._handleDropZone, false);
  }

  ngAfterViewInit() {
    this._attachDragAndDropEventListeners();
  }
}

